import React from "react";
import styled from "styled-components";

export default (props) => {
  if (props.default === false) {
    return props.children
  } else {
    return <div className="container">{props.children}</div>;
  }
};



// WEBPACK FOOTER //
// ./src/_components/Page/index.jsx